import React from 'react';
import { noop } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { TableSearchWidget } from 'ui/containers/TableSearchWidget';
import { layoutConfig } from 'config/table-configs/call-list';
import { tableSearchInlineWidgetPreloader as TableSearchInlineWidgetPreloader } from 'ui/views/widgets/tableSearchInlineWidget';

/*******************************/

// success view
const callListWidgetSuccess = ( props ) => {
    return (
        <div className='ui-call-list-widget'>
            <TableSearchWidget
                templateType='inline'
                layoutConfig={ layoutConfig }
                tableResponse={ props.componentData }
                onActionClick={ props.onActionClick }
                enabledCallBack = { true }
                
                // updateTableOnChange={ true }
            />
        </div>
    );
};

// set display name
callListWidgetSuccess.displayName = 'callListWidgetSuccess';

// set default props
callListWidgetSuccess.defaultProps = {
   componentData: {},
   layoutConfig: {},
   onActionClick: noop,
};

// prop types
callListWidgetSuccess.propTypes = {};

/*******************************/

// preloader view
export const callListWidgetPreloader = ( props ) => {

    // widget class name
    const widgetClassName = classnames( 'ui-call-list-widget-preloader', props.className );

    return (
        <div className={ widgetClassName }>
            <TableSearchInlineWidgetPreloader />
        </div>
    );
};

// set display name
callListWidgetPreloader.displayName = 'callListWidgetPreloader';

// set default props
callListWidgetPreloader.defaultProps = {};

// prop types
callListWidgetPreloader.propTypes = {};

/*******************************/

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { callListWidget as CallListWidget } from 'ui/views/widgets/callListWidget';
 *
 * // render
 * <CallListWidget propName='propValue'/>
 */
export const callListWidget = withNetworkState( callListWidgetPreloader, callListWidgetSuccess );
